import { FormControl } from '@angular/forms';

export interface IEmailForm {
  bank: FormControl<string | null>;

  CompanyId: FormControl<string | null>;
  EventName: FormControl<string>;
  EventType: FormControl<string>;
  Subject: FormControl<string>;
  Template: FormControl<string>;
  TemplateId: FormControl<string>;
}

export interface IEmailTemplateCard {
  bank?: string;
  emailContentTemplate: string;
  messageSummary?: string;
  parameterName?: string;
  parameterValue?: string;
  subject?: string;
  type?: DialogEmailTypeEnum;
}

export interface IEmailTemplateInfo {
  bank?: string | null;
  CompanyId: string | null;
  EventName: string;
  EventType: string;
  Subject: string;
  Template: string;
  TemplateId?: string;
  TriggerValue?: string;
  BankId?: string;
  Name?: string;
  AutomaticEmail?: boolean;
}

export enum DialogEmailTypeEnum {
  Invoice = 'Invoice',
  Transfer = 'Transfer',
  Parameters = 'Parameters',
  StoreConfig = 'StoreConfig',
  ReverseConfig = 'ReverseConfig'
}

export interface ITemplatePayload {
  ParentType: string;
  Type: string;
  Name: string;
  IsList: boolean;
  ListProperties?: ITemplatePayload[];
}

/** Prévia do e-mail de um (sub)lote, montada pela API sem enviar nada. */
export interface IEmailPreview {
  BatchId: string;
  BatchNumber: string;
  BeneficiaryName?: string;
  BeneficiaryDocument?: string;
  /** Falso quando o e-mail deste sublote não sairia; o motivo vem em `Reason`. */
  WillSend: boolean;
  Reason?: string;
  Warnings: string[];
  EventName?: string;
  UsersTo?: string;
  Attachments: string[];
  Subject?: string;
  Body?: string;
}
